module.exports = __webpack_public_path__ + "img/170690.d59b58f0.png";